import { render, staticRenderFns } from "./nextstep.vue?vue&type=template&id=5bdd29d7&scoped=true&"
import script from "./nextstep.vue?vue&type=script&lang=js&"
export * from "./nextstep.vue?vue&type=script&lang=js&"
import style0 from "./nextstep.vue?vue&type=style&index=0&id=5bdd29d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd29d7",
  null
  
)

export default component.exports